import React, { useState } from 'react';

const WeddingSurvey = () => {
  const [formData, setFormData] = useState({
    name: '',
    beThere: '',
    transfer: '',
    mealPreference: '',
    drinkPreference: '',
    allergies: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: value 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const scriptUrl = 'https://script.google.com/macros/s/AKfycbzcqgfeNTC6-N7u3Ri3rjFSp4DxqALtBIdyHrNpKcMTWqiipQSTH3LyJpyV72ULuGPmyg/exec'; 
      const body = JSON.stringify(formData);
  const requestOptions = {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Content-Length": body.length,
      "Host": "script.google.com",
    },
    body: body
  }

  await fetch(scriptUrl, requestOptions);
      
      setSubmitStatus({
        success: true,
        message: 'Спасибо! Ваши данные успешно отправлены.'
      });
      
      setFormData({
        name: '',
        beThere: '',
        transfer: '',
        mealPreference: '',
        drinkPreference: '',
        allergies: ''
      });
      
    } catch (error) {
      setSubmitStatus({
        success: false,
        message: 'Произошла ошибка при отправке. Пожалуйста, попробуйте позже.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="wedding-form-container">
      <div className="wedding-form-card">
        <div className="form-header">
          <h1 className="form-title">Подтвердите присутствие</h1>
          <p className="form-subtitle">Мы будем рады видеть вас на нашей свадьбе!</p>
        </div>
        
        <form onSubmit={handleSubmit} className="wedding-form">
          <div className="form-section">
            <label className="form-label">
              Ваше имя и фамилия*
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                placeholder="Иван Иванов"
                required
              />
            </label>
          </div>

          <div className="form-section">
            <p className="form-question">Планируете ли вы присутствовать?*</p>
            <div className="radio-group">
              {['ДА', 'НЕТ'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="beThere"
                    value={option}
                    checked={formData.beThere === option}
                    onChange={handleCheckboxChange}
                    className="radio-input"
                    required
                  />
                  <span className="radio-custom"></span>
                  {option}
                </label>
              ))}
            </div>
          </div>

          <div className="form-section">
            <p className="form-question">Потребуется ли вам трансфер?</p>
            <div className="radio-group">
              {['ДА', 'НЕТ'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="transfer"
                    value={option}
                    checked={formData.transfer === option}
                    onChange={handleCheckboxChange}
                    className="radio-input"
                  />
                  <span className="radio-custom"></span>
                  {option}
                </label>
              ))}
            </div>
          </div>

          <div className="form-section">
            <p className="form-question">Ваше предпочтение по горячему</p>
            <div className="radio-group column">
              {['МЯСО', 'КУРИЦА', 'РЫБА', 'ВЕГЕТАРИАНСКОЕ БЛЮДО'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="mealPreference"
                    value={option}
                    checked={formData.mealPreference === option}
                    onChange={handleCheckboxChange}
                    className="radio-input"
                  />
                  <span className="radio-custom"></span>
                  {option}
                </label>
              ))}
            </div>
          </div>

          <div className="form-section">
            <label className="form-label">
              Ваши предпочтения по алкогольным напиткам
              <textarea
                name="drinkPreference"
                value={formData.drinkPreference}
                onChange={handleChange}
                className="form-textarea"
                placeholder="Например: красное вино, шампанское"
                rows="3"
              />
            </label>
          </div>

          <div className="form-section">
            <label className="form-label">
              Аллергии или пищевые ограничения
              <textarea
                name="allergies"
                value={formData.allergies}
                onChange={handleChange}
                className="form-textarea"
                placeholder="Укажите продукты, которые вам нельзя"
                rows="3"
              />
            </label>
          </div>

          <button 
            type="submit" 
            className={`submit-btn ${isSubmitting ? 'loading' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner"></span>
                Отправка...
              </>
            ) : 'Подтвердить присутствие'}
          </button>

          {submitStatus && (
            <div className={`form-message ${submitStatus.success ? 'success' : 'error'}`}>
              {submitStatus.message}
            </div>
          )}
        </form>
      </div>

      <style jsx>{`
        .wedding-form-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background-color: #f9f3f0;
          padding: 20px;
          font-family: 'Montserrat', sans-serif;
        }
        
        .wedding-form-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          width: 100%;
          max-width: 600px;
          padding: 40px;
          margin: 20px;
        }
        
        .form-header {
          text-align: center;
          margin-bottom: 32px;
        }
        
        .form-title {
          font-size: 28px;
          color: #5d4037;
          margin-bottom: 8px;
          font-weight: 600;
        }
        
        .form-subtitle {
          color: #8d6e63;
          font-size: 16px;
        }
        
        .form-section {
          margin-bottom: 24px;
        }
        
        .form-label {
          display: block;
          margin-bottom: 8px;
          font-size: 14px;
          color: #5d4037;
          font-weight: 500;
        }
        
        .form-input, .form-textarea {
          width: 100%;
          padding: 12px 16px;
          border: 1px solid #d7ccc8;
          border-radius: 8px;
          font-size: 16px;
          transition: border-color 0.3s;
        }
        
        .form-input:focus, .form-textarea:focus {
          border-color: #a1887f;
          outline: none;
        }
        
        .form-textarea {
          resize: vertical;
          min-height: 100px;
        }
        
        .form-question {
          font-size: 14px;
          color: #5d4037;
          font-weight: 500;
          margin-bottom: 12px;
        }
        
        .radio-group {
          display: flex;
          gap: 20px;
        }
        
        .radio-group.column {
          flex-direction: column;
          gap: 12px;
        }
        
        .radio-label {
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 16px;
          color: #5d4037;
        }
        
        .radio-input {
          position: absolute;
          opacity: 0;
        }
        
        .radio-custom {
          position: relative;
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: 2px solid #a1887f;
          border-radius: 50%;
          transition: all 0.3s;
        }
        
        .radio-input:checked + .radio-custom {
          background-color: #8d6e63;
          border-color: #8d6e63;
        }
        
        .radio-input:checked + .radio-custom::after {
          content: '';
          position: absolute;
          top: 4px;
          left: 4px;
          width: 8px;
          height: 8px;
          background-color: white;
          border-radius: 50%;
        }
        
        .submit-btn {
          width: 100%;
          padding: 16px;
          background-color: #8d6e63;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        
        .submit-btn:hover {
          background-color: #6d4c41;
        }
        
        .submit-btn:disabled {
          background-color: #d7ccc8;
          cursor: not-allowed;
        }
        
        .spinner {
          width: 18px;
          height: 18px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 1s ease-in-out infinite;
        }
        
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        .form-message {
          padding: 12px;
          border-radius: 8px;
          margin-top: 20px;
          text-align: center;
          font-size: 14px;
        }
        
        .form-message.success {
          background-color: #e8f5e9;
          color: #2e7d32;
        }
        
        .form-message.error {
          background-color: #ffebee;
          color: #c62828;
        }
      `}</style>
    </div>
  );
};

export default WeddingSurvey;